import { render, staticRenderFns } from "./health-check.vue?vue&type=template&id=b370d8bc&scoped=true&"
import script from "./health-check.vue?vue&type=script&lang=ts&"
export * from "./health-check.vue?vue&type=script&lang=ts&"
import style0 from "./health-check.vue?vue&type=style&index=0&id=b370d8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b370d8bc",
  null
  
)

export default component.exports